export const API_BASE_URL = `https://stage-api.101drivers.com`; // Deployed

// export const API_BASE_URL = `http://192.168.1.149:3001`; // my local

// export const API_BASE_URL = `http://192.168.1.157:3001`; // Ritesh local

// export const API_BASE_URL = `http://192.168.1.189:3001`; // Garima local

export const GoogleMapApiKey = "AIzaSyA_L3FkfovIhLufnkPMQrHZkAVjKDKuhCU";
